import { fetchDefaultConversation } from '../services/vibeCodingService';

export function getDefaultConversation(args = {}) {
  return async () => fetchDefaultConversation(args);
}
